export default {
  title: 'Importér menu',
  master_title: 'Brandtilstand – importér menu',
  buttons: {
    import: 'Importér',
  },
  toasts: {
    import: {
      pending:
        '⏳Da import nogle gange kan være langsom, foregår den i baggrunden. Tjek restaurantens menu om nogle minutter.',
    },
  },
};
